import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRightSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.5859 9L13.5859 11H7V13H13.5859L11.5859 15L13 16.4141L17.4141 12L13 7.58594L11.5859 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRightSquare;
